import React, { useState } from "react";
import Template from "../images/Orevan-Header.gif";
import { useNavigate } from "react-router-dom";
import {
  faEye,
  faEyeSlash,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../redux/features/auth/authSlice";
import { toast } from "react-toastify";

function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [passwordVisible, setPasswordVisible] = useState(false);

  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.email) newErrors.email = "Email is required";
    if (!form.password) newErrors.password = "Password is required";
    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) return;

    try {
      await dispatch(loginUser(form)).unwrap();
      setForm({ email: "", password: "" });
      toast.success("Login Successfully!");
      navigate("/");
    } catch (error) {
      toast.error("Invalid Credentials");
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="bg-white rounded-2xl border-4 border-white shadow-sm flex flex-col md:flex-row w-full max-w-5xl min-h-[32rem] overflow-hidden">
        {/* Left side with image */}
        <div className="md:w-1/2 w-full min-h-[200px] md:min-h-full">
          <img
            className="h-full w-full object-cover"
            src={Template}
            alt="Orevan Portal"
          />
        </div>

        {/* Right side with content */}
        <div className="md:w-1/2 w-full flex flex-col justify-center text-center p-6 md:p-8">
          <h1 className="font-bold text-4xl mb-6">Orvi Slides</h1>
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col space-y-4">
              {/* Email */}
              <div className="flex flex-col items-start gap-1">
                <label className="text-lg font-semibold text-gray-700">
                  Email
                </label>
                <input
                  type="text"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="border border-slate-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightPurple"
                  placeholder="Enter Your Email"
                />
                {errors.email && (
                  <p className="text-red-500 text-sm font-medium pt-1 pl-1">
                    {errors.email}
                  </p>
                )}
              </div>

              {/* Password */}
              <div className="flex flex-col items-start gap-1 w-full">
                <label className="text-lg font-semibold text-gray-700">
                  Password
                </label>
                <div className="relative w-full">
                  <input
                    name="password"
                    type={passwordVisible ? "text" : "password"}
                    className="border border-slate-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightPurple"
                    placeholder="Enter your password"
                    value={form.password}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    onClick={() => setPasswordVisible(!passwordVisible)}
                    className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                  >
                    <FontAwesomeIcon
                      icon={passwordVisible ? faEye : faEyeSlash}
                    />
                  </button>
                </div>
                {errors.password && (
                  <p className="text-red-500 text-sm font-medium pt-1 pl-1">
                    {errors.password}
                  </p>
                )}

                {/* Forgot Password Button/Link */}
                <div className="w-full text-right mt-1">
                  <button
                    type="button"
                    onClick={() => navigate("/forgot-password")}
                    className="text-sm text-lightPurple font-medium hover:underline hover:text-purpleColor transition duration-200"
                  >
                    Forgot Password?
                  </button>
                </div>
              </div>

              {/* Submit button */}
              <button
                type="submit"
                disabled={loading}
                className={`bg-lightPurple text-white p-2.5 rounded-lg font-semibold transition duration-300 mt-2 ${
                  loading
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-purpleColor"
                }`}
              >
                {loading && (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    className="animate-spin mr-1"
                  />
                )}
                {loading ? "Signing in..." : "Sign In"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
